import { TaggedJourney } from './mapJourneysData';
import { SortOption } from '../components/JourneyCard/SortOptions';

export const sortJourneys = (journeys: TaggedJourney[], by: SortOption): TaggedJourney[] => {
  switch (by) {
    case 'departs-first':
      return [...journeys].sort((a, b) => {
        const lhs = a.legs[0]?.departure || a.legs[0]?.plannedDeparture || '';
        const rhs = b.legs[0]?.departure || b.legs[0]?.plannedDeparture || '';
        if (!lhs || !rhs) return 0;
        return new Date(lhs).getTime() - new Date(rhs).getTime();
      });
      
    case 'arrives-first':
      return [...journeys].sort((a, b) => {
        const lastLegA = a.legs[a.legs.length - 1];
        const lastLegB = b.legs[b.legs.length - 1];
        const lhs = lastLegA?.arrival || lastLegA?.plannedArrival || '';
        const rhs = lastLegB?.arrival || lastLegB?.plannedArrival || '';
        if (!lhs || !rhs) return 0;
        const arrivalDiff = new Date(lhs).getTime() - new Date(rhs).getTime();
        if (arrivalDiff !== 0) return arrivalDiff;
        // Tiebreaker: actual/planned departure
        const ldep = a.legs[0]?.departure || a.legs[0]?.plannedDeparture || '';
        const rdep = b.legs[0]?.departure || b.legs[0]?.plannedDeparture || '';
        if (!ldep || !rdep) return 0;
        return new Date(ldep).getTime() - new Date(rdep).getTime();
      });
      
    case 'fastest':
      return [...journeys].sort((a, b) => {
        const lstart = a.legs[0]?.plannedDeparture || '';
        const lend = a.legs[a.legs.length - 1]?.plannedArrival || '';
        const rstart = b.legs[0]?.plannedDeparture || '';
        const rend = b.legs[b.legs.length - 1]?.plannedArrival || '';
        if (!lstart || !lend || !rstart || !rend) return 0;
        const lduration = new Date(lend).getTime() - new Date(lstart).getTime();
        const rduration = new Date(rend).getTime() - new Date(rstart).getTime();
        if (lduration !== rduration) return lduration - rduration;
        return new Date(lstart).getTime() - new Date(rstart).getTime();
      });
      
    case 'cheapest':
      return [...journeys].sort((a, b) => {
        const lprice = a.price?.amount ?? Number.MAX_SAFE_INTEGER;
        const rprice = b.price?.amount ?? Number.MAX_SAFE_INTEGER;
        if (lprice !== rprice) return lprice - rprice;
        // Tiebreaker: actual/planned departure
        const ldep = a.legs[0]?.departure || a.legs[0]?.plannedDeparture || '';
        const rdep = b.legs[0]?.departure || b.legs[0]?.plannedDeparture || '';
        if (!ldep || !rdep) return 0;
        return new Date(ldep).getTime() - new Date(rdep).getTime();
      });
      
    case 'most-reliable':
      return [...journeys].sort((a, b) => {
        const lrel = a.reliability?.reliabilityScore ?? -1;
        const rrel = b.reliability?.reliabilityScore ?? -1;
        if (lrel !== rrel) return rrel - lrel; // Higher is better
        // Tiebreaker: actual/planned departure
        const ldep = a.legs[0]?.departure || a.legs[0]?.plannedDeparture || '';
        const rdep = b.legs[0]?.departure || b.legs[0]?.plannedDeparture || '';
        if (!ldep || !rdep) return 0;
        return new Date(ldep).getTime() - new Date(rdep).getTime();
      });
      
    case 'least-busy':
      return [...journeys].sort((a, b) => {
        const lscore = a.tagsData?.loadFactorScore ?? Number.MAX_SAFE_INTEGER;
        const rscore = b.tagsData?.loadFactorScore ?? Number.MAX_SAFE_INTEGER;
        if (lscore !== rscore) return lscore - rscore;
        // Tiebreaker: actual/planned departure
        const ldep = a.legs[0]?.departure || a.legs[0]?.plannedDeparture || '';
        const rdep = b.legs[0]?.departure || b.legs[0]?.plannedDeparture || '';
        if (!ldep || !rdep) return 0;
        return new Date(ldep).getTime() - new Date(rdep).getTime();
      });
      
    default:
      return journeys;
  }
};

